import { render, staticRenderFns } from "./ClientWithoutOliverSales.vue?vue&type=template&id=63b95725&scoped=true"
import script from "./ClientWithoutOliverSales.vue?vue&type=script&lang=js"
export * from "./ClientWithoutOliverSales.vue?vue&type=script&lang=js"
import style0 from "./ClientWithoutOliverSales.vue?vue&type=style&index=0&id=63b95725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b95725",
  null
  
)

export default component.exports